import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { setEmms } from "../redux/slices/emmsSlice";
import { CircularProgress } from "@mui/material";
import ErrorMessageComponent from "./ErrorMessageComponent";
import { setApikey } from "../redux/slices/apikeySlice";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "500",
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  paddingTop: 1,
  paddingLeft: 3,
  paddingRight: 3,
  paddingBottom: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 300,
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: 5,
    overflow: "hidden",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  fieldContainer: {
    display: "flex",
    marginBottom: "12px",
    alignItems: "center",
  },

  submitButton: {
    textTransform: "none",
    marginLeft: "70%",
  },
  label: {
    fontWeight: "bold",
  },
}));

export default function MyApikeyForm() {
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const dispatch = useDispatch();
  const oldApikeyData = useSelector((state) => state.apikey);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccessMessage] = useState();
  const [formData, setFormData] = useState({
    name: "",
    type: "",
    key: "",
  });
  const api = localStorage.getItem("api");
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    axios
      .post(api + `/apikeys`, { ...formData }, { headers: headers.headers })
      .then((response) => {
        setIsSubmitting(false);
        if (response.status === 200) {
          const combinedData = [...oldApikeyData.apikey, response.data[0]];

          setErrorModalOpen(true);
          setErrorMessage(`APIKey added successfully`);
          setSuccessMessage(true);
          setFormData({
            name: "",
            type: "",
            key: "",
          });
          try {
            dispatch(setApikey(combinedData));
          } catch (e) {
            console.log(e);
            throw e;
          }
        }
      })
      .catch((error) => {
        setErrorModalOpen(true);
        let errorMessage;

        errorMessage = `Error creating service: <b>${error.response.data}</b><br/>`;

        setErrorMessage(errorMessage);

        setSuccessMessage(false);
        setFormData({
          name: "",
          type: "",
        });
      });

    fetchData();
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };
  function fetchData() {
    axios
      .get(api + `/list/apikeys`, headers)
      .then((response) => {

        dispatch(setApikey(response.data));
      })
      .catch((error) => {
        console.error(error);
      });
  }
  useEffect(() => {
    fetchData();
  }, []);

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };

  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ textTransform: "none", }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Add API Key
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div>
            <h2>API Keys </h2>
            <h4 style={{ fontWeight: "100" }}>
              Add new API Key to the Landscape Manager{" "}
            </h4>
          </div>
          <br />
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("Name:", true)}
                <TextField
                  style={{ width: "28.5ch" }}
                  required
                  id="name"
                  label="Alias for the apikey"
                  name="name"
                  size="small"
                  variant="outlined"
                  value={formData.name}
                  onChange={handleChange}
                />
              </div>
              <div className={classes.fieldContainer}>
                {getLabelWithAsterisk("Type", true)}
                <FormControl
                  style={{ width: "28.5ch" }}
                  variant="outlined"
                  size="small"
                >
                  <InputLabel id="type-label">Type</InputLabel>
                  <Select
                    labelId="type-label"
                    id="type"
                    name="type"
                    value={formData.type}
                    onChange={handleChange}
                    label="Type"
                  >
                    <MenuItem value="Device">Device</MenuItem>
                  </Select>
                </FormControl>
              </div>

            </div>
            <Box
              sx={{
                display: "flex",
                gap: 2,
                mt: 2,
                justifyContent: "end",
                width:"98%"
              }}
            >
              <Button
                style={{ textTransform: "none" }}
                variant="outlined"
                color="primary"
                onClick={() => setOpen(false)}
                disabled={isSubmitting}
              >
                Close
              </Button>
              <Button
                style={{ textTransform: "none" }}
                type="submit"
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Box>

            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                {success ? <h2>Congratulations!</h2> : <h2>Error: </h2>}
                <ErrorMessageComponent errorMessage={errorMessage} />
                <Button
                  style={{
                    textTransform: "none",
                    marginTop: "2%",
                    marginLeft: "75%",
                  }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
